<template>
  <div class="page">
    <h2>Wat is jouw energieverbruik?</h2>
    <form class="page-form">
      <div class="form-row">
        <div class="form-col toggle">
          <label>Weet je precies wat je verbruikt?</label>
          <toggle
            v-model="use_exact_verbruik" 
            label-checked="ja"
            label-unchecked="nee" />
        </div>
      </div>
      <div v-if="use_exact_verbruik" class="form-row">
        <div class="form-col form-col-medium">
          <br />
          <label>Jaarverbruik stroom in kWh<span>*</span></label>
          <input v-model="exact_verbruik" id="consumption_peryear" type="number" placeholder="0000"  />
        </div>
      </div>
      <div v-else class="form-row">
        <div class="form-col form-col-large">
          <br />
          <label>Met hoeveel mensen woon je samen?</label>
          <buttongroup v-model="people_verbruik" />
          <br />
          <label>Het verbruik wordt geschat op <span class="larger" v-html="estimatedVerbruik"></span>kWh</label>
        </div>
      </div>
      <div class="form-row nav-buttons bottom">
        <button v-bind:class="{ enabled : isCompleted }" v-on:click="next()" type="button">Volgende</button>
      </div>
    </form>
  </div>
</template>

<script>
  import toggleComponent from './../components/toggleComponent.vue'
  import buttongroupComponent from './../components/buttongroupComponent.vue'

  export default {
    name: 'verbruikPage',    
    components: {
      'toggle' : toggleComponent,
      'buttongroup' : buttongroupComponent,
    },
    mounted() {
      this.$store.dispatch('set_step_to', this.step)
    },
    data : function() {
      return{
        step : 2
      }
    },
    computed: {
      isCompleted() {
        return this.$store.getters.is_completed_step(this.step)
      },
      estimatedVerbruik() {
        return this.$store.getters.get_estimated_verbruik
      },
      use_exact_verbruik: {
        get () { return this.$store.state.userData.use_exact_verbruik },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'use_exact_verbruik', value: value, step: 2 }) }
      },
      exact_verbruik: {
        get () { return this.$store.state.userData.exact_verbruik },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'exact_verbruik', value: value, step: 2 }) }
      },
      people_verbruik: {
        get () { return this.$store.state.userData.people_verbruik },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'people_verbruik', value: value, step: 2 }) }
      }
    },
    methods : {
      next() {
        if( this.isCompleted == true ) {
          this.$router.push('/gegevens')
        }
      }
    },
  }

</script>

<style scoped lang="scss">
  .larger {
    font-size: 1.35em;
  }
</style>
